<template>
  <div class="sign-in">
    <div class="login-container">
      <div class="login-form">
        <div class="form-header">
          <div class="logo-container">
            <img :src="logoUrl" alt="Gurman Logistics" class="logo" />
          </div>
          <h1>Sign In</h1>
          <p>Enter your username and password to login</p>
        </div>

        <p v-if="isError" class="error">
          Sorry, but you submitted the wrong username or password :(
        </p>

        <a-form
          id="components-form-demo-normal-login"
          :form="form"
          class="login-form-fields"
          @submit="handleSubmit"
          :hideRequiredMark="true"
          layout="vertical"
        >
          <a-form-item label="Email" :colon="false">
            <a-input
              v-decorator="[
                'email',
                {
                  rules: [
                    { required: true, message: 'Please input your email!' },
                  ],
                },
              ]"
              placeholder="Username"
              size="large"
            />
          </a-form-item>
          <a-form-item label="Password" :colon="false">
            <a-input
              v-decorator="[
                'password',
                {
                  rules: [
                    { required: true, message: 'Please input your password!' },
                  ],
                },
              ]"
              type="password"
              placeholder="Password"
              size="large"
            />
          </a-form-item>
          <a-form-item>
            <a-button
              type="primary"
              block
              html-type="submit"
              class="login-form-button"
              size="large"
            >
              SIGN IN
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../../../router/index.js";
import VueCookies from "vue-cookies";
import axios from "axios";

export default {
  data() {
    return {
      form: this.$form.createForm(this, { name: "signin_illustration" }),
      isError: false,
    };
  },
  computed: {
    logoUrl() {
      const userType = process.env.VUE_APP_USER_TYPE || "admin";
      return userType === "admin"
        ? "images/gurman-logo_admin.png"
        : "images/gurman-logo.png";
    },
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.loading = true;

            // Determine login endpoint based on USER_TYPE environment variable
            const userType = process.env.VUE_APP_USER_TYPE || "admin";
            const loginEndpoint =
              userType === "admin" ? "/auth/admin/login" : "/auth/login";

            // Get API base URL from environment variable
            const apiBaseUrl =
              process.env.VUE_APP_BASE_URL ||
              "https://api.gurmanlogistics.com/api";

            console.log(
              `Logging in as ${userType} using endpoint: ${apiBaseUrl}${loginEndpoint}. User type: ${process.env.VUE_APP_USER_TYPE} ws url: ${process.env.VUE_APP_WS_URL}`,
            );

            // Make API request to appropriate login endpoint
            const response = await axios.post(`${apiBaseUrl}${loginEndpoint}`, {
              email: values.email,
              password: values.password,
            });

            console.log(response.status === 200);
            // Handle success response
            if (response.status === 200) {
              VueCookies.set("access_token", response.data.token, "24h");

              // Store user type in localStorage for component access
              localStorage.setItem("userType", userType);

              // Store user/admin data based on login type
              const userData =
                userType === "admin" ? response.data.admin : response.data.user;
              localStorage.setItem("user", JSON.stringify(userData));

              // Re-open the realtime socket so it authenticates with the
              // just-issued token. It was opened anonymously at app start
              // (before login), which otherwise breaks live chat/notifications
              // until a full page refresh.
              try {
                if (this.$ws) {
                  this.$ws.reconnect();
                }
              } catch (wsError) {
                console.warn("WebSocket reconnect after login failed:", wsError);
              }

              // Redirect to the loads list page
              router.push({ name: "Loads List" });
            } else {
              this.isError = true;
            }
          } catch (error) {
            // Handle error response
            this.isError = true;
            console.error(
              "Login failed:",
              error.response?.data || error.message,
            );
          } finally {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sign-in {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;

  .login-container {
    background: white;
    border-radius: 12px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 500px;
    padding: 40px;

    .login-form {
      .form-header {
        text-align: center;
        margin-bottom: 32px;

        .logo-container {
          margin-bottom: 24px;

          .logo {
            height: 60px;
            max-width: 200px;
            object-fit: contain;
          }
        }

        h1 {
          font-size: 28px;
          font-weight: 600;
          color: #333;
          margin-bottom: 8px;
        }

        p {
          color: #666;
          font-size: 16px;
          margin: 0;
        }
      }

      .error {
        color: #ff4d4f;
        font-weight: bold;
        margin-bottom: 20px;
        text-align: center;
        padding: 12px;
        background: #fff2f0;
        border: 1px solid #ffccc7;
        border-radius: 6px;
      }

      .login-form-fields {
        .ant-form-item {
          margin-bottom: 20px;
        }

        .login-form-button {
          height: 45px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .sign-in {
    .login-container {
      padding: 20px;
      margin: 10px;

      .login-form {
        .form-header {
          .logo-container {
            .logo {
              height: 50px;
            }
          }

          h1 {
            font-size: 24px;
          }
        }
      }
    }
  }
}
</style>
